import { render, staticRenderFns } from "./DrawQRCodePoster.vue?vue&type=template&id=4156594c&scoped=true"
import script from "./DrawQRCodePoster.vue?vue&type=script&lang=ts"
export * from "./DrawQRCodePoster.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4156594c",
  null
  
)

export default component.exports